









import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "MainImage",
  computed: {
    ...mapGetters("colors", ["getSelectedColor"])
  }
});
